import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import LazyLoad from '../lazyload';
import useConfig from '../../hooks/useConfig';
var cls = 'image-box';

var ImageBox = function ImageBox(_ref) {
  var className = _ref.className,
      config = _ref.config,
      _onClick = _ref.onClick,
      id = _ref.id,
      pid = _ref.pid,
      render = _ref.render;
  var images = config.images,
      imgType = config.imgType,
      canScroll = config.canScroll,
      spacing = config.spacing;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var nameSpace = createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls);
  var classes = classnames(nameSpace, className, imgType, canScroll, spacing === 'true' ? 'spacing' : '');
  return _jsx("div", Object.assign({
    className: classes,
    "data-pid": pid,
    "data-componentid": id,
    "data-id": id
  }, {
    children: images === null || images === void 0 ? void 0 : images.map(function (item, index) {
      return _jsx("div", Object.assign({
        className: nameSpace + "-item",
        onClick: function onClick() {
          return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
            render: render,
            link: item.normallink,
            deeplink: item.deeplink,
            componentId: id,
            pid: pid
          });
        }
      }, {
        children: _jsx(LazyLoad, Object.assign({
          height: 200
        }, {
          children: _jsx("img", {
            src: item.url,
            alt: ""
          })
        }))
      }), index);
    })
  }));
};

ImageBox.defaultProps = {
  config: {
    images: []
  }
};
ImageBox.displayName = 'ImageBox';
export default ImageBox;